// src/ControlBar.jsx
import React, { useState, useEffect, useRef } from "react";

import icon1 from "./assets/icon1.svg"; // Website Redirect
import icon2 from "./assets/icon2.svg"; // Hide Bar
import icon3 from "./assets/icon3.svg"; // Fullscreen
import icon4 from "./assets/icon4.svg"; // Location
import icon5 from "./assets/icon5.svg"; // Home (Main View)
import icon6 from "./assets/icon6.svg"; // Share
import icon7 from "./assets/icon7.svg"; // Show All Views

import whatsappIcon from "./assets/wa.svg";
import emailIcon from "./assets/mail.svg";
import messageIcon from "./assets/msg.svg";
import callIcon from "./assets/call.svg";

import bookingIcon from "./assets/booking.svg";
import brochureIcon from "./assets/brochure.svg";
import contactIcon from "./assets/contact.svg";
import infoIcon from "./assets/info.svg";

import logo from "./assets/logo.png";

import view0Image from "./assets/view0.png";
import view1Image from "./assets/view1.png";
import view2Image from "./assets/view2.png";
import view3Image from "./assets/view3.png";

const ControlBar = ({ onViewChange }) => {
  const [isHidden, setIsHidden] = useState(false);
  const [popupContent, setPopupContent] = useState(null);
  const [copied, setCopied] = useState(false);

  const [isTablet, setIsTablet] = useState(window.innerWidth <= 1024);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isSmallMobile, setIsSmallMobile] = useState(window.innerWidth <= 428);

  const [isFullscreen, setIsFullscreen] = useState(!!document.fullscreenElement);
  const [isBookingPage, setIsBookingPage] = useState(
    window.location.pathname === "/booking"
  );

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const [tooltip, setTooltip] = useState({ visible: false, text: "", x: 0, y: 0 });
  const tooltipHideTimer = useRef(null);

  const VIEWS = [
    { name: "Arial View", image: view0Image },
    { name: "Main Road", image: view1Image },
    { name: "Street View", image: view2Image },
    { name: "Street View2", image: view3Image },
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsTablet(window.innerWidth <= 1024);
      setIsMobile(window.innerWidth <= 768);
      setIsSmallMobile(window.innerWidth <= 428);

      if (window.innerWidth <= 428) setIsSidebarOpen(false);
    };

    const handleFullscreenChange = () => setIsFullscreen(!!document.fullscreenElement);
    const handlePopState = () => setIsBookingPage(window.location.pathname === "/booking");

    window.addEventListener("resize", handleResize);
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("resize", handleResize);
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  const showTooltip = (e, text) => {
    if (!e?.currentTarget) return;

    if (tooltipHideTimer.current) {
      clearTimeout(tooltipHideTimer.current);
      tooltipHideTimer.current = null;
    }

    const rect = e.currentTarget.getBoundingClientRect();
    const nearRightEdge = rect.right > window.innerWidth - 220;
    const x = nearRightEdge ? rect.left - 12 : rect.left + rect.width / 2;
    const y = rect.top + rect.height / 2;

    setTooltip({ visible: true, text, x, y });
  };

  const hideTooltip = () => {
    tooltipHideTimer.current = setTimeout(() => {
      setTooltip((t) => ({ ...t, visible: false }));
    }, 80);
  };

  const onLongPress = (text) => (e) => {
    if (!isMobile) return;
    showTooltip(e, text);
    setTimeout(() => setTooltip((t) => ({ ...t, visible: false })), 1200);
  };

  const handleWebsiteRedirect = () => window.open("https://essenn.co/", "_blank");
  const handleHideBar = () => setIsHidden((s) => !s);

  const handleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.error(`Error enabling fullscreen: ${err.message}`);
        alert("Failed to enable fullscreen. Please try again.");
      });
    } else {
      document.exitFullscreen();
    }
  };

  const handleLocation = () => {
    setPopupContent(
      <div style={popupStyle}>
        <h3 style={popupHeaderStyle}>Location</h3>
        <p style={popupTextStyle}>
          Clarks Exotica - Sakleshpura, Kamanahalli, Karnataka 573134
        </p>

        <div style={buttonContainerStyle}>
          <button
            onClick={() => window.open("https://maps.app.goo.gl/e8g3VsXiARrojsUG9", "_blank")}
            style={buttonStyle}
          >
            Get Direction
          </button>

          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.779988282292!2d75.79857489999999!3d12.857482099999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba521b00072ee05%3A0x967b68ac961e7290!2sClarks%40%20Sakleshpura!5e0!3m2!1sen!2sin!4v1769763568175!5m2!1sen!2sin"
            width="100%"
            height="280"
            style={{ border: 0, borderRadius: "12px", marginTop: "10px" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Clarks Exotica Sakleshpur"
          />
        </div>

        <button
          style={{ ...closeXStyle, position: "absolute", top: "10px", right: "10px" }}
          onClick={() => setPopupContent(null)}
        >
          ×
        </button>
      </div>
    );
  };

  const handleShare = () => {
    const currentUrl = "https://clarksexoticasakleshpur.com/";

    const handleCopy = () => {
      navigator.clipboard
        .writeText(currentUrl)
        .then(() => {
          setCopied(true);
          alert("Link copied to clipboard!");
          setTimeout(() => setCopied(false), 1500);
        })
        .catch((err) => {
          console.error("Failed to copy:", err);
          alert("Failed to copy link. Please try again.");
        });
    };

    setPopupContent(
      <div style={popupStyle}>
        <h3 style={popupHeaderStyle}>Share With</h3>

        <div style={linkContainerStyle}>
          <span style={{ ...linkTextStyle, color: "#0f1c26" }}>{currentUrl}</span>
          <button onClick={handleCopy} style={{ ...copyButtonStyle, backgroundColor: "#0f1c26" }}>
            {copied ? "Copied!" : "Copy"}
          </button>
        </div>

        <div style={buttonContainerStyle}>
          <button
            onClick={() => window.open(`mailto:?subject=Check this out&body=${currentUrl}`)}
            style={iconChipBtnStyle}
          >
            <img src={emailIcon} alt="Email" style={buttonIconStyle} />
          </button>
          <button
            onClick={() =>
              window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(currentUrl)}`)
            }
            style={iconChipBtnStyle}
          >
            <img src={whatsappIcon} alt="WhatsApp" style={buttonIconStyle} />
          </button>
          <button
            onClick={() => window.open(`sms:?body=${encodeURIComponent(currentUrl)}`)}
            style={iconChipBtnStyle}
          >
            <img src={messageIcon} alt="Message" style={buttonIconStyle} />
          </button>
        </div>

        <button
          style={{ ...closeXStyle, position: "absolute", top: "10px", right: "10px" }}
          onClick={() => setPopupContent(null)}
        >
          X
        </button>
      </div>
    );
  };

  const handleHome = () => onViewChange && onViewChange(0);

  const handleShowAllViews = () => {
    setPopupContent(
      <div style={popupStyle}>
        <h3 style={popupHeaderStyle}>Explore</h3>

        <div style={galleryContainerStyle}>
          {VIEWS.map((view, index) => (
            <button
              key={index}
              onClick={() => {
                onViewChange && onViewChange(index);
                setPopupContent(null);
              }}
              style={galleryButtonStyle}
            >
              <img src={view.image} alt={`View ${view.name}`} style={galleryImageStyle} />
              <span style={galleryTextStyle}>{view.name}</span>
            </button>
          ))}
        </div>

        <button
          style={{ ...closeXStyle, position: "absolute", top: "10px", right: "10px" }}
          onClick={() => setPopupContent(null)}
        >
          X
        </button>
      </div>
    );
  };

  const handleBooking = () => {
    if (isBookingPage) window.location.href = "/explore";
    else window.location.href = "/booking";
  };

  const handleDownloadBrochure = () => {
    setPopupContent(
      <div style={popupStyle}>
        <h3 style={popupHeaderStyle}>Download Brochure</h3>

        <div style={buttonContainerStyle}>
          <a href="./assets/clarks.pdf" download="ClarksExotica.pdf" style={buttonStyle}>
            Download
          </a>
        </div>

        <button
          style={{ ...closeXStyle, position: "absolute", top: "10px", right: "10px" }}
          onClick={() => setPopupContent(null)}
        >
          X
        </button>
      </div>
    );
  };

  const handleContactUs = () => {
    setPopupContent(
      <div style={popupStyle}>
        <h3 style={popupHeaderStyle}>Contact Us</h3>
        <p style={popupTextStyle}>MLA Estates</p>
        <p style={popupTextStyle}>
          #40/1, 1st Floor , 30th Main Road, Jayanagar 7th Block, Bangalore 560041
        </p>
        <p style={popupTextStyle}>Email: crm@landandkey.in</p>
        <p style={popupTextStyle}>Phone: +91-7002727965</p>

        <div style={buttonContainerStyle}>
          <button onClick={() => window.open("mailto:crm@landandkey.in")} style={iconChipBtnStyle}>
            <img src={emailIcon} alt="Email" style={buttonIconStyle} />
          </button>
          <button
            onClick={() => window.open("https://api.whatsapp.com/send?phone=917002727965")}
            style={iconChipBtnStyle}
          >
            <img src={whatsappIcon} alt="WhatsApp" style={buttonIconStyle} />
          </button>
          <button onClick={() => window.open("tel:+917002727965")} style={iconChipBtnStyle}>
            <img src={callIcon} alt="Phone" style={buttonIconStyle} />
          </button>
        </div>

        <button
          style={{ ...closeXStyle, position: "absolute", top: "10px", right: "10px" }}
          onClick={() => setPopupContent(null)}
        >
          X
        </button>
      </div>
    );
  };

  const handleInfo = () => {
    setPopupContent(
      <div style={popupStyle}>
        <h3 style={popupHeaderStyle}>How to</h3>
        <p style={popupTextStyle}>Welcome! Follow these steps to explore:</p>

        <ul style={{ ...popupTextStyle, textAlign: "left", paddingLeft: "20px" }}>
          <li>
            Click <strong>Home</strong> to return to the main view.
          </li>
          <li>
            Use <strong>Explore</strong> to view different perspectives.
          </li>
          <li>
            Tap <strong>Location</strong> to get directions.
          </li>
          <li>
            Select <strong>Share</strong> to share via Email/WhatsApp/SMS.
          </li>
          <li>
            Press <strong>Book Now</strong> to book instantly.
          </li>
          <li>
            Download <strong>Brochure</strong> for detailed info.
          </li>
          <li>
            Use <strong>Fullscreen</strong> for immersive view.
          </li>
          <li>
            Hide the bottom bar using <strong>Toggle</strong>.
          </li>
        </ul>

        <button
          style={{ ...closeXStyle, position: "absolute", top: "10px", right: "10px" }}
          onClick={() => setPopupContent(null)}
        >
          X
        </button>
      </div>
    );
  };

  const popupStyle = {
    position: "fixed",
    bottom: isMobile ? "90px" : "120px",
    left: "50%",
    transform: "translateX(-50%)",
    padding: isMobile ? "10px 15px" : "15px 24px",
    textAlign: "center",
    zIndex: 6000,
    boxShadow: "0 12px 30px rgba(0, 0, 0, 0.35)",
    borderRadius: "16px",
    color: "#0f1c26",
    width: isMobile ? "280px" : "450px",
    background: "rgba(255,255,255,0.78)",
    fontFamily: "Montserrat, sans-serif",
    backdropFilter: "blur(12px)",
    border: "1px solid rgba(255,255,255,0.55)",
  };

  const popupHeaderStyle = {
    margin: "0 0 10px 0",
    fontSize: isMobile ? "16px" : "18px",
    fontWeight: 900,
  };

  const popupTextStyle = {
    margin: "0 0 10px 0",
    fontSize: isMobile ? "12px" : "14px",
    fontWeight: 600,
    opacity: 0.9,
  };

  const linkContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "10px",
    gap: "10px",
  };

  const linkTextStyle = {
    fontSize: isMobile ? "10px" : "12px",
    wordBreak: "break-all",
    fontWeight: 700,
  };

  const copyButtonStyle = {
    padding: isMobile ? "6px 10px" : "6px 12px",
    color: "#ffffff",
    border: "none",
    borderRadius: "12px",
    cursor: "pointer",
    fontSize: isMobile ? "10px" : "12px",
    fontFamily: "Montserrat, sans-serif",
    fontWeight: 900,
    boxShadow: "0 10px 20px rgba(0,0,0,0.18)",
  };

  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "space-around",
    flexWrap: "wrap",
  };

  const buttonStyle = {
    margin: "6px",
    padding: isMobile ? "8px 12px" : "9px 16px",
    background: "#0f1c26",
    color: "white",
    border: "none",
    cursor: "pointer",
    fontSize: isMobile ? "10px" : "12px",
    fontWeight: 900,
    fontFamily: "Montserrat, sans-serif",
    textDecoration: "none",
    borderRadius: "14px",
    boxShadow: "0 12px 24px rgba(0,0,0,0.18)",
  };

  const iconChipBtnStyle = {
    margin: "6px",
    padding: isMobile ? "8px" : "9px",
    background: "rgba(15,28,38,0.06)",
    border: "1px solid rgba(15,28,38,0.10)",
    borderRadius: "14px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backdropFilter: "blur(8px)",
  };

  const buttonIconStyle = {
    width: isMobile ? "18px" : "26px",
    height: isMobile ? "18px" : "26px",
  };

  const iconStyle = {
    width: isMobile ? "30px" : "36px",
    height: isMobile ? "30px" : "36px",
    cursor: "pointer",
    borderRadius: "12px",
    zIndex: 2000,
  };

  const logoStyle = {
    position: "absolute",
    top: "10px",
    left: "10px",
    borderRadius: "16px",
    background: "linear-gradient(180deg, rgba(54, 53, 53, 0.77), rgba(14, 1, 1, 0.57))",
    width: isMobile ? "140px" : "140px",
    zIndex: 1001,
  };

  const containerStyle = {
    position: "fixed",
    bottom: isFullscreen ? "30px" : isMobile ? "30px" : isSmallMobile ? "10px" : "5px",
    left: "50%",
    transform: "translateX(-50%)",
    padding: isMobile ? "6px 10px" : isTablet ? "8px 12px" : "10px 10px",
    borderRadius: "36px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 2000,
    width: isHidden ? (isMobile ? "30px" : "34px") : isMobile ? "300px" : "380px",
    minWidth: isHidden ? (isMobile ? "30px" : "34px") : isMobile ? "300px" : "380px",
    gap: isMobile ? "10px" : "12px",
    transition: "all 0.3s ease",
  };

  const SIDEBAR_W = isMobile ? 160 : 178;

  const sidebarContainerStyle = {
    position: "fixed",
    right: "10px",
    top: "50%",
    width: `${SIDEBAR_W}px`,
    padding: isMobile ? "10px" : "12px",
    borderRadius: "22px",
    zIndex: 0,
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    background: "linear-gradient(180deg, rgba(54, 53, 53, 0.2), rgba(255,255,255,0.08))",
    border: "1px solid rgba(255,255,255,0.28)",
    backdropFilter: "blur(14px)",
    boxShadow: "0 18px 44px rgba(0,0,0,0.30)",
    transition: "transform 0.28s ease",
    transform: `translateY(-50%) translateX(${isSidebarOpen ? "0px" : `${SIDEBAR_W - 28}px`})`,
  };

  const sidebarToggleStyle = {
    position: "absolute",
    left: "-45px",
    top: "50%",
    transform: "translateY(-50%)",
    width: "36px",
    height: "56px",
    borderRadius: "14px",
    border: "1px solid rgba(255,255,255,0.28)",
    background: "linear-gradient(180deg, rgba(54, 53, 53, 0.2), rgba(255,255,255,0.08))",
    backdropFilter: "blur(10px)",
    boxShadow: "0 14px 30px rgba(0,0,0,0.22)",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    userSelect: "none",
  };

  const arrowStyle = {
    fontSize: "24px",
    fontWeight: 900,
    color: "rgba(255,255,255,0.92)",
    lineHeight: 1,
  };

  const sidebarTopRowStyle = { display: "flex", alignItems: "center", gap: "8px" };
  const sidebarTitleStyle = { display: "flex", flexDirection: "column", lineHeight: 1.12 };

  const sidebarHeadlineStyle = {
    margin: 0,
    fontSize: isMobile ? "11px" : "12px",
    fontWeight: 900,
    color: "rgba(255,255,255,0.95)",
    textShadow: "0 10px 22px rgba(0,0,0,0.30)",
  };

  const sidebarSubStyle = {
    margin: "2px 0 0 0",
    fontSize: isMobile ? "9.5px" : "10px",
    fontWeight: 700,
    color: "rgba(255,255,255,0.75)",
  };

  const sidebarDividerStyle = {
    height: "1px",
    width: "100%",
    background: "rgba(255,255,255,0.18)",
    borderRadius: "10px",
  };

  const actionRowStyle = { width: "90%", display: "flex", flexDirection: "column", gap: "8px" };

  const actionBtnStyle = {
    width: "100%",
    height: isMobile ? "46px" : "48px",
    padding: "0 10px",
    borderRadius: "16px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    userSelect: "none",
    background: "rgba(255,255,255,0.10)",
    border: "1px solid rgba(255,255,255,0.20)",
    boxShadow: "0 12px 22px rgba(0,0,0,0.18)",
  };

  const actionLeftStyle = { display: "flex", alignItems: "center", gap: "9px" };

  const actionIconWrapStyle = {
    width: isMobile ? "30px" : "32px",
    height: isMobile ? "30px" : "32px",
    borderRadius: "13px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(255,255,255,0.10)",
    border: "1px solid rgba(255,255,255,0.14)",
  };

  const actionIconStyle = {
    width: isMobile ? "16px" : "17px",
    height: isMobile ? "16px" : "17px",
  };

  const actionTextStyle = { display: "flex", flexDirection: "column", lineHeight: 1.05 };

  const actionMainStyle = {
    fontSize: isMobile ? "10.5px" : "11px",
    fontWeight: 900,
    color: "rgba(255,255,255,0.96)",
  };

  const actionMetaStyle = {
    marginTop: "2px",
    fontSize: isMobile ? "8.5px" : "9px",
    fontWeight: 700,
    color: "rgba(255,255,255,0.70)",
  };

  const actionPillStyle = (tone = "blue") => ({
    fontSize: isMobile ? "8.5px" : "9px",
    fontWeight: 900,
    padding: "5px 9px",
    borderRadius: "999px",
    border: "1px solid rgba(255,255,255,0.20)",
    color: "white",
    background:
      tone === "blue"
        ? "linear-gradient(180deg, rgba(70,134,150,0.92), rgba(46,111,126,0.72))"
        : "rgba(255,255,255,0.14)",
  });

  const closeXStyle = {
    background: "transparent",
    border: "none",
    fontSize: "18px",
    fontWeight: "bold",
    cursor: "pointer",
    color: "#0f1c26",
  };

  const tooltipStyle = {
    position: "fixed",
    left: tooltip.x,
    top: tooltip.y - 30,
    transform:
      tooltip.x < window.innerWidth / 2 ? "translate(-50%, -50%)" : "translate(-100%, -50%)",
    background: "rgba(0,0,0,0.78)",
    color: "white",
    padding: isMobile ? "6px 8px" : "7px 10px",
    borderRadius: "10px",
    fontSize: isMobile ? "10px" : "10px",
    fontFamily: "Montserrat, sans-serif",
    zIndex: 9999,
    pointerEvents: "none",
    whiteSpace: "nowrap",
    boxShadow: "0 10px 26px rgba(0,0,0,0.35)",
  };

  const galleryContainerStyle = {
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    gap: "8px",
    maxHeight: isMobile ? "220px" : "130px",
    maxWidth: isMobile ? "220px" : "550px",
    overflowX: isMobile ? "hidden" : "auto",
    overflowY: isMobile ? "auto" : "hidden",
    padding: "8px",
    scrollbarWidth: "thin",
    scrollbarColor: "#468696",
  };

  const galleryButtonStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid rgba(0,0,0,0.05)",
    cursor: "pointer",
    padding: "6px",
    minWidth: isMobile ? "70px" : "100px",
    fontFamily: "Montserrat, sans-serif",
    background: "rgba(255,255,255,0.55)",
    borderRadius: "14px",
  };

  const galleryImageStyle = {
    width: isMobile ? "80px" : "90px",
    height: isMobile ? "80px" : "90px",
    objectFit: "cover",
    borderRadius: "12px",
  };

  const galleryTextStyle = {
    fontSize: isMobile ? "7px" : "8px",
    fontWeight: 900,
    color: "#0f1c26",
    marginTop: "6px",
    fontFamily: "Montserrat, sans-serif",
    textAlign: "center",
  };

  const TooltipWrap = ({ text, children }) => (
    <div
      onMouseEnter={(e) => showTooltip(e, text)}
      onMouseLeave={hideTooltip}
      onTouchStart={onLongPress(text)}
      style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      {children}
    </div>
  );

  return (
    <>
      <link
        href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap"
        rel="stylesheet"
      />

      <style>{`
        .control-bar-icon { transition: transform 0.18s ease, opacity 0.18s ease; }
        .control-bar-icon:hover { transform: scale(1.12); opacity: 0.92; }

        .action-btn { transition: transform 0.14s ease, box-shadow 0.14s ease, border-color 0.14s ease; }
        .action-btn:hover { transform: translateY(-1px); box-shadow: 0 18px 34px rgba(0,0,0,0.26); border-color: rgba(255,255,255,0.32); }
        .action-btn:active { transform: translateY(0px) scale(0.99); }
      `}</style>

      {tooltip.visible && <div style={tooltipStyle}>{tooltip.text}</div>}

      <img src={logo} alt="Luminexa Logo" style={logoStyle} />

      <div className="control-bar" style={containerStyle}>
        {!isHidden && (
          <TooltipWrap text="Website">
            <img
              src={icon1}
              alt="Visit Website"
              className="control-bar-icon"
              style={iconStyle}
              onClick={handleWebsiteRedirect}
            />
          </TooltipWrap>
        )}

        <TooltipWrap text={isHidden ? "Show Controls" : "Hide Controls"}>
          <img
            src={icon2}
            alt="Toggle Control Bar"
            className="control-bar-icon"
            style={iconStyle}
            onClick={handleHideBar}
          />
        </TooltipWrap>

        {!isHidden && (
          <TooltipWrap text={isFullscreen ? "Exit Fullscreen" : "Fullscreen"}>
            <img
              src={icon3}
              alt="Toggle Fullscreen"
              className="control-bar-icon"
              style={iconStyle}
              onClick={handleFullscreen}
            />
          </TooltipWrap>
        )}

        {!isHidden && !isBookingPage && (
          <TooltipWrap text="Home">
            <img
              src={icon5}
              alt="Go to Main View"
              className="control-bar-icon"
              style={iconStyle}
              onClick={handleHome}
            />
          </TooltipWrap>
        )}

        {!isHidden && (
          <TooltipWrap text="Location">
            <img
              src={icon4}
              alt="View Location"
              className="control-bar-icon"
              style={iconStyle}
              onClick={handleLocation}
            />
          </TooltipWrap>
        )}

        {!isHidden && (
          <TooltipWrap text="Share">
            <img
              src={icon6}
              alt="Share Page"
              className="control-bar-icon"
              style={iconStyle}
              onClick={handleShare}
            />
          </TooltipWrap>
        )}

        {!isHidden && !isBookingPage && (
          <TooltipWrap text="Explore Views">
            <img
              src={icon7}
              alt="Show All Views"
              className="control-bar-icon"
              style={iconStyle}
              onClick={handleShowAllViews}
            />
          </TooltipWrap>
        )}
      </div>

      <div className="sidebar" style={sidebarContainerStyle}>
        <div
          style={sidebarToggleStyle}
          role="button"
          tabIndex={0}
          onClick={() => setIsSidebarOpen((s) => !s)}
        >
          <span style={arrowStyle}>{isSidebarOpen ? "›" : "‹"}</span>
        </div>

        <div style={sidebarTopRowStyle}>
          <div style={sidebarTitleStyle}>
            <p style={sidebarHeadlineStyle}>Premium Villa&apos;s</p>
            <p style={sidebarSubStyle}>in Sakleshpura</p>
          </div>
        </div>

        <div style={sidebarDividerStyle} />

        {!isHidden ? (
          <div style={actionRowStyle}>
            <div className="action-btn" style={actionBtnStyle} onClick={handleBooking} role="button" tabIndex={0}>
              <div style={actionLeftStyle}>
                <div style={actionIconWrapStyle}>
                  <img src={bookingIcon} alt="Booking" style={actionIconStyle} />
                </div>
                <div style={actionTextStyle}>
                  <div style={actionMainStyle}>{isBookingPage ? "Explore" : "Book Now"}</div>
                  <div style={actionMetaStyle}>Instant booking</div>
                </div>
              </div>
              <div style={actionPillStyle("blue")}>Go</div>
            </div>

            <div
              className="action-btn"
              style={actionBtnStyle}
              onClick={handleDownloadBrochure}
              role="button"
              tabIndex={0}
            >
              <div style={actionLeftStyle}>
                <div style={actionIconWrapStyle}>
                  <img src={brochureIcon} alt="Brochure" style={actionIconStyle} />
                </div>
                <div style={actionTextStyle}>
                  <div style={actionMainStyle}>Brochure</div>
                  <div style={actionMetaStyle}>Download PDF</div>
                </div>
              </div>
              <div style={actionPillStyle("glass")}>PDF</div>
            </div>

            <div className="action-btn" style={actionBtnStyle} onClick={handleContactUs} role="button" tabIndex={0}>
              <div style={actionLeftStyle}>
                <div style={actionIconWrapStyle}>
                  <img src={contactIcon} alt="Contact" style={actionIconStyle} />
                </div>
                <div style={actionTextStyle}>
                  <div style={actionMainStyle}>Contact</div>
                  <div style={actionMetaStyle}>Call / WhatsApp</div>
                </div>
              </div>
              <div style={actionPillStyle("glass")}>24×7</div>
            </div>

            <div className="action-btn" style={actionBtnStyle} onClick={handleInfo} role="button" tabIndex={0}>
              <div style={actionLeftStyle}>
                <div style={actionIconWrapStyle}>
                  <img src={infoIcon} alt="Info" style={actionIconStyle} />
                </div>
                <div style={actionTextStyle}>
                  <div style={actionMainStyle}>How to</div>
                  <div style={actionMetaStyle}>Quick guide</div>
                </div>
              </div>
              <div style={actionPillStyle("glass")}>Tip</div>
            </div>
          </div>
        ) : (
          <div
            style={{
              padding: "10px 10px",
              borderRadius: "16px",
              border: "1px dashed rgba(255,255,255,0.22)",
              color: "rgba(255,255,255,0.82)",
              fontWeight: 800,
              fontSize: isMobile ? "10px" : "11px",
              textAlign: "center",
            }}
          >
            Controls hidden
          </div>
        )}
      </div>

      {popupContent && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0, 0, 0, 0.5)",
            zIndex: 1500,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={() => setPopupContent(null)}
        >
          <div onClick={(e) => e.stopPropagation()}>{popupContent}</div>
        </div>
      )}
    </>
  );
};

export default ControlBar;